import { render } from "./albumCover.vue?vue&type=template&id=b6e1ac72&scoped=true"
import script from "./albumCover.vue?vue&type=script&lang=js"
export * from "./albumCover.vue?vue&type=script&lang=js"

import "./albumCover.vue?vue&type=style&index=0&id=b6e1ac72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e1ac72"]])

export default __exports__